<template>
  <div
    style="position:relative;height:100%;"
  >
    <div
        class="standard-content"
        :class="{ 'mobile-content': $vuetify.breakpoint.xs}"
        style="padding: 25px;"
    >
        <div
            class="last-message"
            style="position:relative;margin:auto;margin-top:100px;font-size:16px;vertical-align:middle;z-index:0;border-radius: 15px;background-color: rgba(0,25,68,0.1);width:100%;max-width:800px;height:auto;"
        >
            <div
                v-if="$route.query.outage"
                style="width:100%;padding: 25px;"
            >
                <v-icon
                    color="warning"
                    size="72"
                    style="padding-right: 15px;display:inline-block;"
                >
                    mdi-alert-rhombus
                </v-icon>
                <div
                    style="display:inline-block;"
                >
                    <span style="font-size:24px;"><b>Awaiting Signature</b></span><br />
                    Electronic signatures are temporarily unavailable.<br />We'll email you when your document is ready to sign.
                </div>
            </div>
            <div
                v-else
                style="width:100%;padding: 25px;"
            >
                <v-icon
                    color="green"
                    size="72"
                    style="padding-right: 15px;display:inline-block;"
                >
                    mdi-check-circle
                </v-icon>
                <div
                    style="display:inline-block;"
                >
                    <span style="font-size:24px;"><b>Submitted</b></span><br /><br />
                </div>
                <div
                    v-if="$route.query.message"
                    style="padding: 10px;margin-top: 15px;background: rgba(0,25,68,0.1);border-radius: 15px;"
                >
                    {{ $route.query.message }}
                </div>
            </div>
        </div>
        <div
            style="max-width: 800px;margin:auto;margin-top: 55px;"
        >
            <v-alert
                :value="true"
                type="info"
            >
                Your form has been submitted. Please contact <span class="legalFoot" /> if you need to make changes.
            </v-alert>
            <v-card
                v-if="availableForms.length > 0"
                style="margin-top: 20px;"
            >
                <v-toolbar
                    flat
                >
                    <b>Other Forms Requiring Your Attention</b>
                </v-toolbar>
                <v-card-text>
                    <v-layout
                        v-if="availableForms.length > 0"
                        row
                        wrap
                    >
                        <v-flex
                            v-for="form in availableForms"
                            :key="form.id"
                            xs12
                            class="standard-form-card"
                            :class="{ 'mobile-form-card': $vuetify.breakpoint.xs}"
                        >
                            <v-card    
                                class="form-card"
                                style="cursor:pointer;"
                                @click="$router.push({ name: 'ClientForm', params: { id: $route.params.id, form_id: form.id } })"
                            >
                                <v-card-text
                                    style="border-bottom: 1px solid rgba(0,0,0,0.1);"
                                >
                                    <div
                                        style="font-size: 16px;font-weight: bold;"
                                    >
                                        {{form.name}}
                                    </div>
                                    <div>
                                        {{ convertToLocal(form.created_at) }}
                                    </div>
                                    <br />
                                    <span
                                        v-if="form.party_name"
                                        style="font-weight: bold;"
                                    >
                                        {{form.party_name}}
                                    </span>
                                    <span
                                        v-if="form.form_number"
                                        style="font-style: italic;"
                                    >
                                        ({{form.form_number}})
                                    </span>
                                </v-card-text>
                                <v-card-text
                                    v-if="!form.is_new"
                                    style="padding-top: 5px;padding-bottom:5px;"
                                >
                                    <div
                                        style="font-size: 12px;"
                                    >
                                        <b>Last Updated: </b> {{convertToCalRef(form.updated_at)}}
                                    </div>
                                </v-card-text>
                                <v-card-actions
                                    style="background: rgba(0,0,0,0.15);border-top: 1px solid rgba(0,0,0,0.1);"
                                >
                                    <v-spacer />
                                    <v-btn
                                        v-if="form.is_signing"
                                        color="warning"
                                    >
                                        Sign Form
                                    </v-btn>
                                    <v-btn
                                        v-else-if="form.is_new"
                                        color="green"
                                        dark
                                    >
                                        Start Form
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        color="primary"
                                    >
                                        Open Form
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
            <v-card
                v-else
                style="margin-top: 20px;"
            >
                <v-card-text
                    style="text-align:center;"
                >
                    <h3>
                        You have no other forms that require your attention.
                    </h3>
                </v-card-text>
            </v-card>
            <v-card
                elevation="0"
                style="margin-top: 25px;"
            >
                <v-card-actions>
                    <v-btn
                        color="primary"
                        :to="{name: 'Home'}"
                    >
                        Go Home
                    </v-btn>
                    <v-spacer />
                    <v-btn
                        flat
                        color="primary"
                        :to="{name: 'Forms', params: { id: $route.params.id }}"
                    >
                        Forms
                    </v-btn>
                    <v-btn
                        flat
                        color="primary"
                        :to="{name: 'Messages'}"
                    >
                        Messages
                    </v-btn>
                </v-card-actions>
            </v-card>
        </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'

export default {
    name: 'UserFormSubmitted',
    data () {
        return {
            forms: [],
            loading: false
        }
    },
    created () {
        this.fetchForms()
    },
    methods: {
        fetchForms () {
            this.loading = true
            api.userform.contactUserForm.list({ count: 25 })
                .then(data => {
                    this.forms = data.results
                })
        },
    },
    computed: {
        availableForms () {
            var forms = []
            var count = 0
            this.forms.forEach((form) => {
                if (count == 3)
                    return
                if (!form.client_readonly || form.is_signing) {
                    forms.push(form)
                    count++
                }
            })
            return forms
        },
    }
}
</script>


<style scoped>
    .standard-content {
        max-height: calc(100vh);
        height:100%;
        overflow-y:auto;
        position: relative;
    }
    .mobile-content {
        max-height: calc(100vh - 56px) !important;
        position: relative;
    }

    .form-card {
        position: relative;
    }

    .standard-form-card {
        padding-right: 15px;
        padding-top: 15px;
    }

    .mobile-form-card {
        padding-top: 15px;
        padding-right: 0 !important;
    }
</style>